




























































import Vue from "vue";
import { mapActions, mapMutations, mapState } from "vuex";

export interface NotificationProps {
  isActive: boolean;
}

export default Vue.extend({
  name: "vc-notification",
  computed: {
    ...mapState("common", ["notificationItem"]),
  },
  methods: {
    ...mapMutations("common", ["deleteNotification"]),
    ...mapActions("common", ["createNotification"]),
  },
  mounted() {
    if (sessionStorage.getItem("label")) {
      this.createNotification({
        label: sessionStorage.getItem("label"),
        style: sessionStorage.getItem("style"),
      });
      sessionStorage.removeItem("label");
      sessionStorage.removeItem("style");
    }
  },
});
